import Dashboard from './dashboard'

export default Dashboard



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js